import React from "react";
import { AlertCircle } from "lucide-react";
import { Card, CardContent, Button } from "../ui";
import useTriageJobStatus from "../../hooks/useTriageJobStatus";
import TriageTerminalHUD from "./TriageTerminalHUD";
import FilingSuccessPanel from "./FilingSuccessPanel";

/**
 * Live status for one triage job (GET /api/v1/triage/:id).
 * Renders terminal HUD during processing and success panel when FILED.
 */
export default function JobStatusCard({ jobId, onRetry }) {
  const { status, error, isLoading } = useTriageJobStatus(jobId);

  if (!jobId) return null;

  if (error && !status) {
    return (
      <Card variant="error">
        <CardContent className="p-6">
          <div className="flex items-start gap-3">
            <AlertCircle className="h-5 w-5 text-error mt-0.5" />
            <div>
              <p className="font-medium text-error-900">Could not load filing status</p>
              <p className="text-sm text-error-700 mt-1">{error.message}</p>
              {onRetry && (
                <Button variant="outline" size="sm" className="mt-3" onClick={onRetry}>
                  Try again
                </Button>
              )}
            </div>
          </div>
        </CardContent>
      </Card>
    );
  }

  return (
    <div className="space-y-4">
      <TriageTerminalHUD status={status} error={error} isLoading={isLoading} />
      {status?.state === "FILED" && <FilingSuccessPanel status={status} />}
    </div>
  );
}
